import _ from 'lodash';

export default function selector(storeState) {
    return {
        isInitialized: _.get(storeState, 'conversionsDashboard.isInitialized'),
        advertisers: _.get(storeState, 'conversionsDashboard.advertisers', []),
        advertiserIdSelected: _.get(storeState, 'conversionsDashboard.advertiserIdSelected', []),
    };
}
